import React, { FC } from 'react';
import { Grid } from '@backstage/ui';
import { EntityAboutCard } from '@backstage/plugin-catalog';
import { EntityWarningContent } from './EntityWarningContent';
import { EntityLinksGridItem } from './EntityLinksGridItem';
import { HasComponentsGridItem } from './HasComponentsGridItem';
import { HasConsumersGridItem } from './HasConsumersGridItem';
import { DependsOnComponentsGridItem } from './DependsOnComponentsGridItem';
import { DependsOnResourcesGridItem } from './DependsOnResourcesGridItem';
import { ProvidedApisGridItem } from './ProvidedApisGridItem';
import { ConsumedApisGridItem } from './ConsumedApisGridItem';
import { DeploysComponentsGridItem } from './DeploysComponentsGridItem';
import {
  EntityDeploymentsCard,
  isDeploymentsAvailable,
} from '@appfolio/backstage-plugin-deployments';
import { Show } from '@appfolio/backstage-components';
import { DistributesComponentsGridItem } from './DistributesComponentsGridItem';
import { DistributedByComponentsGridItem } from './DistributedByComponentsGridItem';

export const ComponentOverviewContent: FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <Grid.Root columns="12" gap="4">
      {EntityWarningContent}
      <Grid.Item colSpan={{ initial: '12', md: '6' }}>
        <EntityAboutCard />
      </Grid.Item>
      <EntityLinksGridItem colSpan={{ initial: '12', md: '6' }} />
      <Show if={isDeploymentsAvailable}>
        <Grid.Item colSpan={{ initial: '12', md: '6' }}>
          <EntityDeploymentsCard />
        </Grid.Item>
      </Show>
      <DeploysComponentsGridItem colSpan={{ initial: '12', md: '6' }} />
      <DistributesComponentsGridItem colSpan={{ initial: '12', md: '6' }} />
      <DistributedByComponentsGridItem colSpan={{ initial: '12', md: '6' }} />
      <HasComponentsGridItem
        colSpan={{ initial: '12', md: '6' }}
        title="Has subcomponents"
      />
      <HasConsumersGridItem colSpan={{ initial: '12', md: '6' }} />
      <DependsOnComponentsGridItem colSpan={{ initial: '12', md: '6' }} />
      <DependsOnResourcesGridItem colSpan={{ initial: '12', md: '6' }} />
      <ProvidedApisGridItem colSpan={{ initial: '12', md: '6' }} />
      <ConsumedApisGridItem colSpan={{ initial: '12', md: '6' }} />
      {children}
    </Grid.Root>
  );
};
